import { makeStyles } from "@material-ui/core";


export default makeStyles(() => ({
    actionButtons: {
        display: "flex",
        flexWrap: "nowrap",
        position: "absolute",
        zIndex: 4,
        bottom: 10,
        right: 10,
        "& > button": {
            marginRight: 8,
        },
    },
    fadeControls: {
        position: "absolute",
        height: "100%",
        width: "100%",
        opacity: 0.2,
        transition: "opacity 0.15s linear 0.5s",
        "&:hover": {
            opacity: 1,
            transitionDelay: "0s",
        },
    },
    fullscreen: {
        top: 10,
        right: 10,
    },
    panTilt: {
        paddingRight: 10,
    },
    ptz: {
        display: "flex",
        position: "absolute",
        bottom: 10,
        left: 10,
    },

    // Lottie animations
    centerAnimation: {
        position: "absolute",
        top: "calc(50% - 20px)",
        left: "calc(50% - 20px)",
        height: 60,
        width: 60,
        borderRadius: "50%",
        backgroundColor: "black",
        opacity: "70%",
    },
    upArrow: {
        transform: "rotate(.25turn)",
    },
    downArrow: {
        transform: "rotate(.75turn)",
    },
    leftArrow: {
        transform: "rotate(0turn)",
    },
    rightArrow: {
        transform: "rotate(.5turn)",
    },
}));
